import {  IJointType } from "./joint";

export interface IBaseType {
  id: string;
  joint_name: string;
  sectionID?: string;
  page: number;
  x: number;
  y: number;
  label_x: number;
  label_y: number;
  type: string;
  lock: boolean;
  createdDate: number;
  sourceElementID?: string;
  marked?: boolean;
  [key: string]: string | number | undefined | boolean;
}



export type IElementType = IBaseType | IJointType;


export interface IExtendElementType extends IJointType {
  kks?: string;
  projectID?: string;
}

export interface IReferenceElement {
  id: string;
  sectionID: string;
  page: number;
  sourceElementID: string;
  x: number;
  y: number;
  label_x: number;
  label_y: number;
  lock: boolean;
  createdDate: number;
}

export interface IOption {
  value: string | number
  label: string | number
}

export const resultScope = [
  {
    value: 'ok',
    label: 'ok'
  },
  {
    value: 'not_ok',
    label: 'not ok'
  },
  {
    value: '-',
    label: '-'
  }
]
